/**
 * @fileoverview OrganizationTag — inline tag pairing the Blueprint `office`
 * icon with an organization name. Used in places like "Managed by
 * {OrganizationTag}" beneath an authorized-application row, and any other
 * Multipass surface that names the owning org of a resource.
 *
 * Foundry mapping: `markings__organization` containing
 * `bp6-icon-office markings__icon` + `markings__name`.
 */

import { Icon } from "@blueprintjs/core";
import type { ReactElement } from "react";

interface OrganizationTagProps {
  name: string;
  className?: string;
}

export function OrganizationTag({
  name,
  className,
}: OrganizationTagProps): ReactElement {
  return (
    <span data-testid="organization-tag"
      className={["bp-organization-tag", className].filter(Boolean).join(" ")}
    >
      <Icon icon="office" size={12} className="bp-organization-tag-icon" />
      <strong className="bp-organization-tag-name">{name}</strong>
    </span>
  );
}
